import { render, staticRenderFns } from "./CompBannerToTarif.vue?vue&type=template&id=ff83908c"
import script from "./CompBannerToTarif.vue?vue&type=script&lang=js"
export * from "./CompBannerToTarif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports